import { render, staticRenderFns } from "./FarmPhotoRegistration.vue?vue&type=template&id=47969280&"
import script from "./FarmPhotoRegistration.vue?vue&type=script&lang=js&"
export * from "./FarmPhotoRegistration.vue?vue&type=script&lang=js&"
import style1 from "./FarmPhotoRegistration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
